import { Component, OnInit } from '@angular/core';
import {CommonUtilities} from '../../assets/js/common-utilities';
declare var $: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  // visibility= true;
  router: true;

  constructor(private utility:CommonUtilities) { }

  ngOnInit(): void {
    this.utility.pageLoadScript();
    $(document).ready(function() {
      $('[data-toggle-second="tooltip"]').tooltip();
      $('[data-toggle-second="tooltip"]').on('click', function () {
        $(this).tooltip('hide');
      });
    });
    $(".modal").on("shown.bs.modal", function () {
      $('[data-toggle-second="tooltip"]').tooltip({ trigger: "hover" });
    });
  }

}
